const examInfo = {
	state: {
		data:{
			'code': '1',
			'message': '',
			'data': {
				'examInfoId': 0,
				'subject': '国考',
				'examInfoName': '天下第一考',
				'examInfoUserName': '神秘人',
				'examDate': '',
				'answerGetScore': 0,
				'totalScore': 0,
				'grade': null,
				'winRate': 0,
				'level': '',
				'realDuration': 0,
				'suggestTime': 0,
				'averageTime': 0,
				'totalQuestionCount': 0,
				'rightQuestionCount': 0,
				'partRightQuestionCount': 0,
				'wrongQuestionCount': 0,
				'questionListDetail': [],
				'knowledgeNum': 0,
				'knowledgeList': [
					[],
					[],
					[]
				],
				'abilityList': []
			}
		},
		accessToken:'',
		examInfoId:'',
		examInfoType:'',
	},
	mutations: {
		SET_DATA: (state, data) => {
			state.data = data
		},
		SET_TOKEN: (state, token) => {
			state.accessToken = token
		},
		SET_EXAMID: (state, id) => {
			state.examInfoId = id
		},
		SET_EXAMTYPE: (state, type) => {
			state.examInfoType = type
		}
	},
	actions: {
		SetData({ commit }, data) {
			commit('SET_DATA', data)
		},
		SetToken({ commit }, token) {
			commit('SET_TOKEN', token)
		},
		SetExamId({ commit }, id) {
			commit('SET_EXAMID', id)
		},
		SetExamType({ commit }, type) {
			commit('SET_EXAMTYPE', type)
		},
	}
}

export default examInfo



// WEBPACK FOOTER //
// ./src/store/modules/data.js